import { render, staticRenderFns } from "./ProjectManage.vue?vue&type=template&id=900a9cce&scoped=true&"
import script from "./ProjectManage.vue?vue&type=script&lang=js&"
export * from "./ProjectManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900a9cce",
  null
  
)

export default component.exports